import React from 'react';
import PropTypes from 'prop-types';
import './MealInfo.css';
import Dictionary from '../../../model/Dictionary';

const MealInfo = ({ passenger, meals }) => (
  <div className='meal-info-wrapper column'>
    {passenger.meals.map((meal, index) => (
      <div key={`meal-info-${index}-${passenger.id}-${meal.id}`} className='meal-info'>
        <div className='meal-info-container'>
          <h6>{meal.title}</h6>
          <p>{meal.info}</p>
          {meal.subselectionTitle && meal.description ? (
            <div className='meal-subselection-container'>
              <h6>{meal.subselectionTitle}</h6>
              <p>{meal.description}</p>
            </div>
          ) : null}
        </div>
      </div>
    ))}
    <div className='meal-info'>
      <div className='meal-info-container'>
        <h6>{Dictionary.meal.notes}</h6>
        <p>{passenger.notes && passenger.notes.length ? passenger.notes : '-'}</p>
      </div>
    </div>
  </div>
);

MealInfo.propTypes = {
  passenger: PropTypes.object,
  meals: PropTypes.arrayOf(PropTypes.object),
};

export default MealInfo;



// WEBPACK FOOTER //
// ./src/components/review/mealInfo/MealInfo.js